module.exports = __webpack_public_path__ + "media/images/s01_02-8b04b2aedd18ee3cd42134150e1161a2.svg";